export default __webpack_public_path__ + "static/media/form3.c404fb42.png";